<div class="channel-container">
    <div class="channel-wrap" *ngIf="vessel">
        <div class="channel-header">
            <div class="title-container">
                <h1 class="title" data-cy="channels-page-all-headers">
                    {{ 'channel.title' | translate }}
                    <span class="version" data-cy="channels-page-header-1">
                        {{ vessel.name }}
                    </span>
                    <span class="version" data-cy="channels-page-header-divider">
                        {{ '-' }}
                    </span>
                    <span class="version" data-cy="channels-page-header-2">
                        {{ ('channel.version' | translate) + ' ' + vessel.projectVersion }}</span
                    >
                </h1>
                <div class="button-wrap">
                    <ng-container *ngIf="this.selectedTab === this.TAB_DEFAULT">
                        <div class="autosave-container" [class.lowOpacity]="!this.userCanEdit">
                            <div
                                class="autosave-status"
                                *ngIf="isAutosaveEnabled"
                                [ngClass]="{ save_error: hasSaveError() }">
                                <div *ngIf="hasSaveError()">
                                    <mat-icon svgIcon="save-error" class="error-icon" />
                                </div>

                                <mat-icon *ngIf="!hasSaveError()" [svgIcon]="getAutosaveIcon()" class="autosave-icon" />
                                <div>
                                    {{ getAutosaveStatus() }}
                                </div>
                            </div>
                            <ng-container *ngIf="hasSaveError() && isAutosaveEnabled">
                                <div class="save-error-button" (click)="openErrorMessage()">
                                    {{ 'channel.header.autosave.error.button' | translate }}
                                </div>
                            </ng-container>
                            <div class="autosave-title">
                                <ng-container *ngIf="isAutosaveEnabled">
                                    {{ 'channel.header.autosave.enabled.title' | translate }}
                                </ng-container>
                                <ng-container *ngIf="!isAutosaveEnabled">
                                    {{ 'channel.header.autosave.disabled.title' | translate }}
                                </ng-container>
                            </div>
                            <div class="autosave-slider">
                                <mat-slide-toggle
                                    class="autosave-toggle"
                                    [checked]="isAutosaveEnabled"
                                    (change)="updateAutosave($event)"
                                    [disabled]="!this.userCanEdit" />
                            </div>
                        </div>
                    </ng-container>
                    <button (click)="cancel()" class="white" data-cy="channels-back-button">
                        {{ 'channel.label.cancel' | translate }}
                    </button>
                    <button [disabled]="!isSaveEnabled" (click)="save()" class="primary" data-cy="channels-save-button">
                        {{ 'channel.label.save' | translate }}
                    </button>
                </div>
            </div>
            <div class="sub-header">
                <div class="tabs-container">
                    <div
                        class="tab"
                        data-cy="channels-alarms-tab"
                        (click)="tabChange(TAB_DEFAULT)"
                        [class.select]="selectedTab === TAB_DEFAULT">
                        {{ 'channel-sheet.tab.alarm' | translate }}
                    </div>
                    <div
                        class="tab"
                        data-cy="channels-alarm-group-tab"
                        (click)="tabChange(TAB_ALARM_GROUP)"
                        [class.select]="selectedTab === TAB_ALARM_GROUP">
                        {{ 'channel-sheet.tab.alarm-group' | translate }}
                    </div>
                    <div
                        class="tab"
                        data-cy="channels-repose-group-tab"
                        (click)="tabChange(TAB_REPOSE)"
                        [class.select]="selectedTab === TAB_REPOSE">
                        {{ 'channel-sheet.tab.repose' | translate }}
                    </div>
                    <div
                        class="tab"
                        data-cy="channels-running-hour-tab"
                        (click)="tabChange(TAB_RUNNING_HOUR)"
                        [class.select]="selectedTab === TAB_RUNNING_HOUR">
                        {{ 'channel-sheet.tab.running-hour' | translate }}
                    </div>

                    <div
                        class="tab"
                        data-cy="channels-exhaust-gas-setting-tab"
                        (click)="tabChange(TAB_EXHAUST_GAS)"
                        [class.select]="selectedTab === TAB_EXHAUST_GAS">
                        {{ 'channel-sheet.tab.exhaust-gas' | translate }}
                    </div>

                    <div
                        class="tab"
                        data-cy="channels-sensor-cable-tag-tab"
                        (click)="tabChange(TAB_SENSOR_CABLE)"
                        [class.select]="selectedTab === TAB_SENSOR_CABLE">
                        {{ 'channel-sheet.tab.sensor-cable-tag' | translate }}
                    </div>

                    <div class="tab" (click)="tabChange(TAB_LOGIC)" [class.select]="selectedTab === TAB_LOGIC">
                        {{ 'channel-sheet.tab.logic' | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="selectedTab === TAB_DEFAULT" class="channel-contents">
            <app-channel-sheet
                class="channel-sheet-container"
                [vessel]="vessel"
                [userCanEdit]="userCanEdit"
                (pageUpdated)="onPageUpdated($event)"
                #channelSheet></app-channel-sheet>
            <app-side-menu class="side-menu-container"></app-side-menu>
        </div>
        <app-alarm-group-setting
            *ngIf="selectedTab === TAB_ALARM_GROUP"
            [vessel]="vessel"
            [userCanEdit]="userCanEdit"
            (pageUpdated)="onPageUpdated($event)"
            #alarmGroupSetting></app-alarm-group-setting>
        <app-repose-setting
            *ngIf="selectedTab === TAB_REPOSE"
            [vessel]="vessel"
            [userCanEdit]="userCanEdit"
            (pageUpdated)="onPageUpdated($event)"
            #reposeSetting></app-repose-setting>

        <app-running-hour-setting
            *ngIf="selectedTab === TAB_RUNNING_HOUR"
            [vessel]="vessel"
            [userCanEdit]="userCanEdit"
            (pageUpdated)="onPageUpdated($event)"
            #runningHourSetting></app-running-hour-setting>
        <app-exhaust-gas-setting
            *ngIf="selectedTab === TAB_EXHAUST_GAS"
            [vessel]="vessel"
            [userCanEdit]="userCanEdit"
            (pageUpdated)="onPageUpdated($event)"
            #exhaustGasSetting></app-exhaust-gas-setting>
        <app-sensor-cable-tag
            style="display: flex; min-height: 0"
            *ngIf="selectedTab === TAB_SENSOR_CABLE"
            [vessel]="vessel"
            [userCanEdit]="userCanEdit"
            (pageUpdated)="onPageUpdated($event)"
            #sensorCableTag></app-sensor-cable-tag>

        <app-channels-logic
            style="display: flex; min-height: 0"
            *ngIf="selectedTab === TAB_LOGIC"
            [vessel]="vessel"
            [userCanEdit]="userCanEdit"
            (pageUpdated)="onPageUpdated($event)"
            #channelsLogic>
        </app-channels-logic>
    </div>
</div>

<app-locked-vessel-notification [vessel]="vessel" [pageName]="getMessageName()"></app-locked-vessel-notification>

<div class="sheet-loading" *ngIf="(isSheetLoading || !vessel) && selectedTab === TAB_DEFAULT">
    <app-loading-spinner></app-loading-spinner>
</div>

<app-confirmation-window
    #exitPageConfirmation
    [mainLabel]="'channel.page.exit-confirmation.title'"
    [discardLabel]="'channel.page.exit-confirmation.discard'"
    [goBackLabel]="'channel.page.exit-confirmation.go-back'"
    [saveLabel]="'channel.page.exit-confirmation.save'"></app-confirmation-window>
